import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";
import {translate} from '@elements/translations';
import {findIn} from '@elements/dom-utils';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import * as smoothScroll from "@elements/smooth-scroll";
smoothScroll.init({
    scrollOffset: 150
});

// Todo: Add page specific JS here e.g:
import {init} from '@elements/anchor-nav/bootstrap-5';
setTimeout(function() {
    init(
        {
            renderItem: function (text, anchor) {
                return '<li class="main-navbar__list-item nav-item js-ancher-nav__item"><a href="#' + anchor + '" class="main-navbar__link js-smoothscroll__link js-ancher-nav__link nav-link" data-scroll-offset="200" data-smoothscroll-offset="200"><span class="d-flex flex-column"><span class="main-navbar__link-text">' + text + '</span></span></a></li>';
            },
            smoothScroll: true,
            scrollSpy: true,
            scrollSpyTarget: '.js-anchor-nav',
            scrollSpyOffset: 100
        },
        {
            list: '.js-anchor-nav__list',
            item: '.js-anchor-nav__item'
        }
    );
}, 300);

import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';

import * as scrollSlider from '@elements/scroll-slider';
scrollSlider.init({
    arrowIconClass:"icon icon-chevron-right",
    dots: true,
    arrowRenderFunction: arrowRenderFunction
}, {
    base: '.js-scroll-slider',
    area: '.js-scroll-slider__area',
    item: '.js-scroll-slider__item',
    dotsContainer: '.js-scroll-slider__dots-container'
});

function arrowRenderFunction(container, direction, disabled, options) {
    console.log("container",container);
    let markupElement = document.createElement('div'),
        arrowMarkup = `<button type="button" class="${options.arrowClass} ${direction === 0 ? options.arrowPrevClass : options.arrowNextClass}" ${disabled ? 'disabled' : ''}><span class="scroll-slider__arrow-icon icon ${direction === 0 ? 'icon-arrow-left' :  'icon-arrow-right' }" aria-label="${translate('scroll-slider-'+ direction + '')}" title="${translate('scroll-slider-'+ direction + '')}"></span></button>`;
    markupElement.innerHTML = arrowMarkup;
    let newArrow = markupElement.childNodes[0];
    let arrowContainer = findIn('.js-scroll-slider__arrow-wrapper', container);
    arrowContainer.appendChild(newArrow);
    return newArrow;
}

import * as playVideo from './scripts/play-video';
playVideo.init();

import * as lightbox from '@elements/lightbox';
lightbox.init();

import * as conditionalForm from './scripts/conditional-form';
conditionalForm.init();

import * as parallax from './scripts/parallax';
parallax.initInScope();

const isDesktop = matchMedia('(min-width: 768px)').matches;
import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init({
    submitOnChange: isDesktop,
    addUrlParams: true
});

import * as openModalOnPageload from './scripts/open-modal-on-pageload';
openModalOnPageload.init();

